//
//
//
//
//
//
//
//
//
//
//
//

import { faFileDownload } from '@fortawesome/pro-regular-svg-icons';

export default {
  name: 'product-card-action-download-sample',
  data() {
    return {
      faFileDownload,
    };
  },
};
